import actions from '@/store/modules/synthetics/endpoints/endpoints.actions';
import mutations from '@/store/modules/synthetics/endpoints/endpoints.mutation';
import getters from '@/store/modules/synthetics/endpoints/endpoints.getters';
import {
  basicInfoDefaultData,
  reqDetailsDefaultData,
  additionalOptnsDefaultData,
  authDetailsDefaultData
} from '@/components/SM/Endpoints/sm.endpoints.types';
import _ from 'lodash';

export interface State {
  currentGroupId: Number;
  totalEndpointsForGroup: Number;
  currentEndpointId: String;
  formData: EndpointForm;
  allMappedEndpointsDeleted: Boolean,
  dispOnlyFillDetails: Boolean
}

interface EndpointForm {
  isValid: Boolean;
  basicInfoConfig: Object;
  authConfig: Object;
  requestConfig: Object;
  additionalOptions: Object;
}

export const initialState: State = {
  currentGroupId: -1,
  currentEndpointId: '',
  totalEndpointsForGroup: 0,
  formData: {
    isValid: false,
    basicInfoConfig: _.cloneDeep(basicInfoDefaultData),
    authConfig: _.cloneDeep(authDetailsDefaultData),
    requestConfig: _.cloneDeep(reqDetailsDefaultData),
    additionalOptions: _.cloneDeep(additionalOptnsDefaultData)
  },
  allMappedEndpointsDeleted: false,
  dispOnlyFillDetails: false
};

export default {
  namespaced: true,
  state: initialState,
  mutations: mutations,
  getters: getters,
  actions: actions
};
